import React from "react";
import { Input, Button } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { ActionFooter } from "../components/ActionFooter";

export function QrCodeScreen({
	captureResponse,
	isCopied,
	copyToClipboard,
	handleModalClose,
	primaryColor,
}) {
	return (
		<>
			<div className="bg-white min-h-[596px] flex flex-col items-center justify-center">
				<div
					className="mb-8 p-1 bg-white rounded-xl border-2"
					style={{ borderColor: primaryColor }}
				>
					{captureResponse?.capture?.qr_code && (
						<img
							src={captureResponse.capture.qr_code}
							alt="QR Code"
							style={{ width: 280, height: 280 }}
						/>
					)}
				</div>
				<div className="w-full max-w-md">
					<Input
						size="large"
						value={captureResponse?.capture?.url || ""}
						readOnly
						addonAfter={
							isCopied
								? <CheckOutlined className="cursor-pointer text-green-500" />
								: <CopyOutlined
										onClick={() =>
											copyToClipboard(captureResponse?.capture?.url)
										}
										className="cursor-pointer"
									/>
						}
					/>
				</div>
			</div>
			<ActionFooter>
				<Button
					size="large"
					shape="round"
					type="primary"
					onClick={handleModalClose}
					className="border-0 text-white !px-12 shadow-none"
				>
					<FormattedMessage id="close" />
				</Button>
			</ActionFooter>
		</>
	);
}
